/**
 * Page images of the open editor live in memory only (object URLs inside the
 * editor iframe). This registry lets logout drop them in every mounted
 * editor at once.
 */

/** Same name as CLEAR_PAGE_IMAGES_GLOBAL in external/page_images.ts. */
export const CLEAR_PAGE_IMAGES_GLOBAL = 'anonifyClearPageImages';

const clearers = new Set<() => void>();

/** Returns the unregister function. */
export const registerPageImageClearer = (clear: () => void): (() => void) => {
  clearers.add(clear);
  return () => {
    clearers.delete(clear);
  };
};

/** Drop all in-memory page images (logout). */
export const clearPageImageCaches = () => {
  clearers.forEach((clear) => {
    try {
      clear();
    } catch {
      // A torn-down iframe must not stop the others (or the logout).
    }
  });
};

/**
 * The editor iframe's clear function. Taken while the iframe is alive, so it
 * can still be called after the iframe element is gone.
 */
export const iframePageImageClearer = (
  win: Window | null | undefined
): (() => void) | undefined => {
  try {
    const clear = (win as unknown as Record<string, unknown> | null)?.[
      CLEAR_PAGE_IMAGES_GLOBAL
    ];
    return typeof clear === 'function' ? (clear as () => void) : undefined;
  } catch {
    return undefined;
  }
};
